import { actions, CurrentUserWithAdminFlags } from './reducer'
import ssapi from 'lib/api/secondstepApi'
import { addNotification } from 'store/notifications'
import { UpdateUserProfileRequest, GroupMembership } from 'types'

export const fetchCurrentUser = () => {
  return async function (dispatch) {
    dispatch(actions.fetchingCurrentUser())

    try {
      const { data } = await ssapi.getUserProfile()
      const groups = data.groupMembership || []

      const currentUser: CurrentUserWithAdminFlags = {
        ...data,
        isCssAdmin: groups.includes(GroupMembership.CSS_ADMINS),
        isTechnologyAdmin: groups.includes(GroupMembership.TECHNOLOGY_ADMINS),
        isOperationsAdmin: groups.includes(GroupMembership.OPERATIONS_ADMINS),
        isAdmin: Object.values(GroupMembership).some(group =>
          groups.includes(group),
        ),
      }

      dispatch(actions.fetchCurrentUserSuccess(currentUser))

      return currentUser
    } catch (error) {
      dispatch(
        actions.fetchCurrentUserError(
          error instanceof Error
            ? error.message
            : 'Error fetching current user',
        ),
      )
      return false
    }
  }
}

/**
 * Updates the current user's profile and refreshes the current user data
 */
export const updateUserProfile = (profileData: UpdateUserProfileRequest) => {
  return async function (dispatch) {
    dispatch(actions.updatingUserProfile())

    try {
      await ssapi.updateUserProfile(profileData)
      dispatch(
        addNotification({
          color: 'success',
          text: 'Successfully updated profile',
        }),
      )
      await dispatch(fetchCurrentUser())
      dispatch(actions.updateUserProfileSuccess())
    } catch (error) {
      const response = (error as any)?.response
      const data = response?.data || ''
      const text = !data ? 'Failed to update profile' : data
      dispatch(
        addNotification({
          color: 'danger',
          text: text,
        }),
      )
      dispatch(actions.updateUserProfileError(text))
    }
  }
}

/**
 * Clears the update status flags
 */
export const clearUpdateStatus = () => {
  return function (dispatch) {
    dispatch(actions.clearUpdateStatus())
  }
}

/**
 * Clears the current user from state
 */
export const clearCurrentUser = () => {
  return function (dispatch) {
    dispatch(actions.clearCurrentUser())
  }
}
